
"use strict";
import { oBase, Ilk, oBool, oColor, oCsv, oDaton, oDatim, oDouble, oFloat, oHomin, oInt16, oInt32, oInt64, oMay, oMemo, oText, oWkd } from "../util/ovars";
import { DIALOG_AUX_FUNCTIONS } from "../util/classes";
import { Whisper } from "../util/classes";
import { UTL } from "../util/classes";
//ADD_KABIN
// done
// done
// done
// done
// done

/**
 * DIALOG21 Static Class
 * this is HComfimt  this dialog is confimation for DELETE
 */
export class DIALOG21 {
    // --- Static Elements (Variables) ---
    public static overlay_element: HTMLDivElement = null;
    public static popup_element: HTMLElement = null;
    public static caption_element: HTMLElement = null;
    public static case_element: HTMLElement = null;
    public static close_button_element: HTMLSpanElement = null;
    public static defo_button_element: HTMLElement = null;
    public static panel_element: HTMLElement = null;
    public static ok_button_element: HTMLElement = null;

    // --- Static State Variables ---
    public static MD_FLAG = false;
    public static defo_button_is_clicked = false;
    public static Vamod_MouseX = 0;
    public static Vamod_MouseY = 0;
    public static Vamod_ModalWindowLeftX = 0;
    public static Vamod_ModalWindowTopY = 0;
    public static par_callback_function: Function = null;
    public static par_text_content = "";

    public static readonly BID = {
        UNDEFINED: 0,
        OK: 1,
    }; // note that we need this ';' because this block is a command 

    public static var_current_pseudo_focused_btn = 1; // BID.OK

    // --- Methods ---

    public static refresh_pseudo_focus_for_all_buttons() {
        DIALOG_AUX_FUNCTIONS.put_pseudo_focus_indcator(DIALOG21.ok_button_element, DIALOG21.var_current_pseudo_focused_btn == DIALOG21.BID.OK);
    }

    public static respond_tab() {
        DIALOG21.var_current_pseudo_focused_btn = UTL.GET_NEW_INDEX_Forward(DIALOG21.var_current_pseudo_focused_btn, DIALOG21.BID.OK, DIALOG21.BID.OK);
        DIALOG21.refresh_pseudo_focus_for_all_buttons();
    }

    public static respond_shift_tab() {
        DIALOG21.var_current_pseudo_focused_btn = UTL.GET_NEW_INDEX_Backward(DIALOG21.var_current_pseudo_focused_btn, DIALOG21.BID.OK, DIALOG21.BID.OK);
        DIALOG21.refresh_pseudo_focus_for_all_buttons();
    }

    public static create_overlay_element() {
        const overlay_element = document.createElement("div");
        overlay_element.style.position = "fixed";
        overlay_element.style.top = "0";
        overlay_element.style.left = "0";
        overlay_element.style.width = "100%";
        overlay_element.style.height = "100%";
        overlay_element.style.backgroundColor = "rgba(0, 0, 0, 0.5)"; // Semi-transparent black
        overlay_element.style.zIndex = "1000"; // Ensure overlay is on top
        return overlay_element;
    }

    public static create_popup_element() {
        const popup_element = document.createElement("div");
        popup_element.id = "id-DIALOG21-popup";
        popup_element.style.position = "absolute";
        popup_element.style.backgroundColor = "#fff";
        popup_element.style.padding = "0px";
        popup_element.style.borderRadius = "8px";
        popup_element.style.width = "320px";
        popup_element.style.textAlign = "center";

        //position: fixed;
        return popup_element;
    }

    public static create_caption_element() {
        const caption = document.createElement("div");
        caption.textContent = "DIALOG21";
        caption.style.fontSize = "24px";
        caption.style.fontWeight = "bold";
        caption.style.margin = "0px";
        caption.style.padding = "0px";
        caption.style.backgroundColor = DIALOG_AUX_FUNCTIONS.get_caption_backgroundColor();
        caption.style.color = DIALOG_AUX_FUNCTIONS.get_caption_forgroundColor();
        caption.style.borderTopLeftRadius = "5px";
        caption.style.borderTopRightRadius = "5px";
        caption.style.userSelect = "none";
        return caption;
    }

    public static create_close_button(): HTMLSpanElement {
        const element = DIALOG_AUX_FUNCTIONS.create_close_button_element();
        return element;
    }

    public static create_defo_button(): HTMLSpanElement {
        const element = DIALOG_AUX_FUNCTIONS.create_defo_button_element();
        return element;
    }

    public static create_case_element() {
        const element = document.createElement("div");
        element.id = "id-DIALOG21-case"; // the id is for debug of focus
        element.style.backgroundColor = "yellow";
        UTL.remove_outline_for_focusable_element(element);
        element.style.fontSize = "25px";
        //element.style.width = "80%"; // ערך זה נקבע בניסוי וטעיה
        element.style.padding = "22px";
        element.style.margin = "auto";
        element.style.fontWeight = "700";
        element.style.direction = "rtl";
        element.textContent = DIALOG21.par_text_content;
        //element.innerHTML = par_text_content;
        element.style.whiteSpace = "pre-line";
        return element;
    }

    public static create_panel_element() {
        const buttonsContainer = document.createElement("div");
        buttonsContainer.style.marginTop = "6px";
        buttonsContainer.style.display = "flex";
        buttonsContainer.style.justifyContent = "space-around";
        buttonsContainer.style.backgroundColor = DIALOG_AUX_FUNCTIONS.get_panel_backgroundColor();
        buttonsContainer.style.marginBottom = "6px";
        return buttonsContainer;
    }

    public static create_ok_button_element() {
        const element = DIALOG_AUX_FUNCTIONS.create_ok_button_element();
        UTL.MakeElementUnFocusable(element);
        return element;
    }

    public static overlay_mousedown(event: MouseEvent) {
        const target_element = event.target;
        if (target_element == DIALOG21.caption_element) {
            // caption אנחנו רוצים שניתן יהיה לגרור רק דרך ה
            // caption אנחנו רוצים שניתן יהיה לגרור רק דרך ה
            const popup_element_bounding_rect = DIALOG21.popup_element.getBoundingClientRect();
            DIALOG21.MD_FLAG = true;
            DIALOG21.Vamod_MouseX = event.clientX;
            DIALOG21.Vamod_MouseY = event.clientY;
            DIALOG21.Vamod_ModalWindowLeftX = popup_element_bounding_rect.left;
            DIALOG21.Vamod_ModalWindowTopY = popup_element_bounding_rect.top;
        }
        if (target_element == DIALOG21.defo_button_element) {
            DIALOG21.defo_button_is_clicked = true;
        }
    }

    public static overlay_mousemove(event: MouseEvent) {
        if (DIALOG21.MD_FLAG == true) {
            //alert("mouse move");
            const delta_x = event.clientX - DIALOG21.Vamod_MouseX;
            const delta_y = event.clientY - DIALOG21.Vamod_MouseY;
            DIALOG21.popup_element.style.left = (DIALOG21.Vamod_ModalWindowLeftX + delta_x) + "px";
            DIALOG21.popup_element.style.top = (DIALOG21.Vamod_ModalWindowTopY + delta_y) + "px";
            //alert(`mousemove22: delta_x=${delta_x} delta_y=${delta_y}`);
        }
    }

    public static overlay_mouseup(event: MouseEvent) {
        const freezed_defo_button_is_clicked = DIALOG21.defo_button_is_clicked;
        DIALOG21.MD_FLAG = false;
        DIALOG21.defo_button_is_clicked = false;
        if (freezed_defo_button_is_clicked == false) {
            // כי זה יקלקל את הבדיקה case_element אנחנו לא רוצים לבצע פוקוס ל defo_button במקרה שבו לחצנו על ה
            // כי זה יקלקל את הבדיקה case_element אנחנו לא רוצים לבצע פוקוס ל defo_button במקרה שבו לחצנו על ה
            // כי זה יקלקל את הבדיקה case_element אנחנו לא רוצים לבצע פוקוס ל defo_button במקרה שבו לחצנו על ה
            DIALOG21.case_element.focus(); // body בורח ל focus כיוון שה focus יש לבצע כאן
        }
    }

    public static perform_pseudo_focused_button() {
        if (DIALOG21.var_current_pseudo_focused_btn == DIALOG21.BID.OK) {
            DIALOG21.perform_ok();
        }
    }

    public static overlay_keydown(event: KeyboardEvent) {
        if (event.key === 'Enter') {
            //perform_ok();
            DIALOG21.perform_pseudo_focused_button();
        }
        if (event.key === 'Escape') {
            DIALOG21.perform_ok();
        }
        if (event.key === 'ArrowLeft') {
            event.preventDefault(); // <-- this disables the default behavior
        }
        if (event.key === 'ArrowRight') {
            event.preventDefault(); // <-- this disables the default behavior
        }
        if (event.key === 'ArrowUp') {
            event.preventDefault(); // <-- this disables the default behavior
        }
        if (event.key === 'ArrowDown') {
            event.preventDefault(); // <-- this disables the default behavior
        }
        if (event.key === 'Delete') {
        }
        if (event.key === 'Backspace') {
        }
        if (event.key === 'Tab') {
            event.preventDefault(); // <-- this disables the default behavior
            if (event.shiftKey == false) DIALOG21.respond_tab();
            if (event.shiftKey == true) DIALOG21.respond_shift_tab();
        }

        if (event.key === 'F7') {
            event.preventDefault(); // <-- this disables the default behavior
            //UTL.show_which_element_has_focus();
        }

        if (event.key === ' ') {
            event.preventDefault(); // <-- this disables the default behavior
        }
        if (UTL.string_contains_digit(event.key) == true) {
            event.preventDefault(); // <-- this disables the default behavior
        }
    }

    public static create_new_br_element() {
        // אחד חשוב ליצור כל אחד בנפרד כאן <br> במידה ורוצים להוסיף יותר מאשר אלמנט
        const new_br_element = document.createElement('br');
        return new_br_element;
    }

    public static paint_colors_in_select_elements(element: HTMLElement, bval: boolean) {
        if (bval == false) {
            element.style.backgroundColor = "white";
            element.style.color = "black";
        }
        if (bval == true) {
            element.style.backgroundColor = "blue";
            element.style.color = "white";
        }
    }


    public static perform_given_pars() {
        if (DIALOG21.par_callback_function != null) {
            document.body.removeChild(DIALOG21.overlay_element);
            const delay_in_milliseconds = 0;
            if (true) {
                // refresh כדי שיתבצע setTimeout() אנחנו משתמשים ב
                setTimeout(DIALOG21.par_callback_function, delay_in_milliseconds, false);
            }
            if (false) {
                DIALOG21.par_callback_function(false);
            }
        }
        else {
            alert("callback_function != null");
        }
    }

    public static perform_defo() {
        // defo = DEbug FOcul
        // defo = DEbug FOcul
        // defo = DEbug FOcul
        UTL.show_which_element_has_focus();
    }

    public static create_dialog(p_callback_function: Function, p_text_content: string): void {
        //this is HComfimt  this dialog is confimation for DELETE
        //this is HComfimt  this dialog is confimation for DELETE
        //this is HComfimt  this dialog is confimation for DELETE
        debugger;
        DIALOG21.par_callback_function = p_callback_function;
        DIALOG21.par_text_content = p_text_content;

        DIALOG21.overlay_element = DIALOG21.create_overlay_element();
        DIALOG21.popup_element = DIALOG21.create_popup_element();
        DIALOG21.caption_element = DIALOG21.create_caption_element();
        DIALOG21.close_button_element = DIALOG21.create_close_button();
        DIALOG21.defo_button_element = DIALOG21.create_defo_button(); // defo = DEbug FOcul

        DIALOG21.case_element = DIALOG21.create_case_element();

        DIALOG21.panel_element = DIALOG21.create_panel_element();
        DIALOG21.ok_button_element = DIALOG21.create_ok_button_element();

        DIALOG21.overlay_element.appendChild(DIALOG21.popup_element);
        DIALOG21.caption_element.appendChild(DIALOG21.close_button_element);
        DIALOG21.caption_element.appendChild(DIALOG21.defo_button_element);
        DIALOG21.popup_element.appendChild(DIALOG21.caption_element);
        if (false) {
            DIALOG21.popup_element.appendChild(DIALOG21.create_new_br_element());
        }

        DIALOG21.popup_element.appendChild(DIALOG21.case_element);

        DIALOG21.popup_element.appendChild(DIALOG21.panel_element);
        DIALOG21.panel_element.appendChild(DIALOG21.ok_button_element);
        DIALOG21.overlay_element.addEventListener("mousedown", DIALOG21.overlay_mousedown);
        DIALOG21.overlay_element.addEventListener("mousemove", DIALOG21.overlay_mousemove);

        DIALOG21.overlay_element.addEventListener("mouseup", DIALOG21.overlay_mouseup);
        DIALOG21.overlay_element.addEventListener("keydown", DIALOG21.overlay_keydown);
        DIALOG21.defo_button_element.addEventListener("click", DIALOG21.perform_defo);
        DIALOG21.ok_button_element.addEventListener("click", DIALOG21.perform_ok);
        DIALOG21.close_button_element.addEventListener("click", DIALOG21.perform_ok);
        document.body.appendChild(DIALOG21.overlay_element);
        UTL.center_popup_element_inside_overlay_element(DIALOG21.popup_element, DIALOG21.overlay_element);
        DIALOG21.var_current_pseudo_focused_btn = DIALOG21.BID.OK;
        DIALOG21.refresh_pseudo_focus_for_all_buttons();
        UTL.MakeElementFocusable(DIALOG21.case_element);
        DIALOG21.case_element.focus();
    }

    public static perform_ok() {
        const output_result = true;
        DIALOG21.perform_given_pars();
    }
}